import SubscriptionIdentitySelectModal, {
  SUBSCRIPTION_IDENTITY_SELECT_MODAL,
} from './modal';

export { SUBSCRIPTION_IDENTITY_SELECT_MODAL };

export default SubscriptionIdentitySelectModal;
